module.exports = __webpack_public_path__ + "static/media/medal.1fb3d9b2.svg";